import React from "react";
import { SelectPrimary, FormWithMargin } from "../styles/styledComponents";
import MenuItem from "@mui/material/MenuItem";
import { InputLabel } from "@mui/material";

interface OptionSelectProps {
    title: string;
    options: string[];
    selectedOption: string;
    onChange: (event: any) => void;
    showError?: boolean;
};

export function OptionSelect({title, options, selectedOption, onChange, showError=false}: OptionSelectProps) {
    const makeMenuItems = () => {
        if (!options || options.length === 0) {
            return <MenuItem value="">No options</MenuItem>
        }
        return options.map((option) => {
            return <MenuItem value={option}>{option}</MenuItem>
        })
    };
    const isError = selectedOption === "" && showError;

    return <FormWithMargin>
        <InputLabel id={`select${title}Label`}>{title}</InputLabel>
        <SelectPrimary 
            error={isError}
            labelId={`select${title}Label`}
            value={selectedOption}
            id={`select${title}`}
            label={title}
            onChange={onChange}>
            {makeMenuItems()}
        </SelectPrimary>
    </FormWithMargin>
}

export function useOptionSelect(title: string, options: string[], showError: boolean = false) {
    const [selectedOption, setSelectedOption] = React.useState<string>("");
    const [isOptionSelected, setIsOptionSelected] = React.useState<boolean>(false);
    const setSelection = (option: string) => { 
        if(!options.includes(option)) {
            setSelectedOption("");
            setIsOptionSelected(false);
            if(option !== "") console.error(`Option ${option} is not in the list of options`);
            return;
        }
        setSelectedOption(option);
        setIsOptionSelected(true);
    }
    const handleChange = (event: any) => {
        console.log(event.target.value);
        setSelectedOption(event.target.value);
        setIsOptionSelected(true);
        console.log(`selectedOption: ${selectedOption}`);
    }
    const component = <OptionSelect 
        title={title} 
        options={options}
        selectedOption={selectedOption} 
        onChange={handleChange} 
        showError={showError}
    />
    return {
        component,
        selectedOption,
        setSelection,
        isOptionSelected
    }
}